import { defineMessages } from "react-intl.macro";

export default defineMessages({
    tableOfContentsTitle: {
        id: "toc.title",
        description: "Displayed above table of contents",
        defaultMessage: "Contents",
    },
});
